export default __webpack_public_path__ + "static/media/photo_2022-05-15_11-02-31.84b3c88a.jpg";